import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';

import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsContinueButton = (props: Props) => {
  const { disabled, onPress } = props;

  return (
    <Button
      size="large-wide"
      style={styles.button}
      width="100%"
      palette="primary"
      disabled={disabled}
      onPress={onPress}
      accessibilityRole="button"
    >
      <FormattedMessage {...messages.continueAction} />
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  continueAction: {
    defaultMessage: 'Continue',
    description: 'Add To Bag | Unavailable ingredients | Continue CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  disabled: boolean;
  onPress: () => void;
};
